import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import Player from '@vimeo/player';
import { NGXLogger } from 'ngx-logger';
import { StateService } from '../../../core/providers/state/state.service';

@Component({
  selector: 'vsf-vimeo-fullscreen-preview',
  templateUrl: './vimeo-fullscreen-preview.component.html',
  styleUrls: ['./vimeo-fullscreen-preview.component.scss']
})
export class VimeoFullscreenPreviewComponent implements OnInit, OnDestroy {
  @Input() videoId!: number; // Make videoId required and remove default value
  @Input() visible = false;
  private player: Player | null = null;

  constructor(private stateService: StateService, private logger: NGXLogger) {}

  ngOnInit() {
    if (this.videoId) {
      this.initializePlayer();
    } else {
      this.logger.error('Video ID is required for VimeoFullscreenPreviewComponent');
    }
  }

  ngOnDestroy() {
    if (this.player) {
      this.player.destroy();
    }
  }

  private initializePlayer() {
    if (!this.videoId) {
      this.logger.error('Cannot initialize player: Video ID is not set');
      return;
    }

    const vw = document.documentElement.clientWidth;
    const vh = document.documentElement.clientHeight;
    const isDesktop = vw >= 768;
    const width  = isDesktop ? vw * 0.8 : vw;
    const height = isDesktop ? vh * 0.8 : vh;

  this.player = new Player('vimeo-fullscreen-player', {
      id: this.videoId,
      width,
      height,
      loop: true,
      muted: true,
      controls: true,
      autoplay: true,
    });

    this.player.ready().then(() => {
      if (this.player) {
        this.player.play().catch(error => {
          this.logger.error('Error playing video:', error);
        });
      }
    }).catch(error => {
      this.logger.error('Error initializing Vimeo player:', error);
    });
  }

  closeFullscreen() {
    this.stateService.setState('fullscreenPreviewOpen', null);
  }
}